import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appAutofocus]'
})
export class AutofocusDirective implements OnInit{
    @Input() appAutofocus = false;

    constructor(private elementReference: ElementRef){}

    ngOnInit(): void{
        if(this.appAutofocus) setTimeout(() => this.elementReference.nativeElement.focus(), 250);
    }
}
